<aside class="control-sidebar control-sidebar-dark" style="overflow: scroll;">
		<!-- Control sidebar content goes here -->
		<div class="p-3">
			<!-- <h5>CONFIGURACIONES</h5> -->
		</div>

		<div class="col-md-12 mt-10" [routerLink]="['/main/miperfil']" style="cursor: pointer;" data-widget="control-sidebar" data-slide="true">


			<div class="card card-widget widget-user">
				<!-- Add the bg color to the header using any of the bg-* classes -->
				<div class="widget-user-header bg-info">
					<h3 class="widget-user-username">{{usuario.nombres}}</h3>
					<h5 class="widget-user-desc">{{usuario.email}}</h5>
					
				</div>
				<div class="widget-user-image">
					<img class="img-circle elevation-2" src="assets/img/main/icon.png" alt="Proliga Isotipo" title="Proliga Isotipo">
				</div>
			</div>
		</div>
		

		<br>


		


		<hr>
		<div class="p-3 text-center">
			<p>Optimizado y desarrollado por Software Planet</p>
			<div class="col-md-12 float-bottom">
				<a href="https://softwareplanet.mx" target="_blank"><img src="assets/img/main/sp.png" width="70%" alt="Software Planet"></a>
			</div>	
		</div>
		<hr>


		<div class="p-3">
			<button class="btn btn-danger btn-block" (click)="logout()" data-widget="control-sidebar" data-slide="true">
				<i class="fas fa-sign-out-alt"></i> | Cerrar sesión 
			</button>
		</div>
		
		

</aside>